// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"92d7ff6e","284":"94f90814","412":"dd9aedfa","743":"639f76a8"}[chunkId] + ".css";
};